import React from 'react';

export const SITE_URL = 'https://patinhas-sem-lar.pt';

interface SEOProps {
  title: string;
  description: string;
  path: string;
  image?: string;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  path,
  image = `${SITE_URL}/og-cover.jpg`,
}) => {
  const url = `${SITE_URL}${path}`;
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </>
  );
};

export default SEO;
